import { createIcon } from '@chakra-ui/icons';

export const LongAnswer = createIcon({
  displayName: 'LongAnswer',
  viewBox: '0 0 24 24',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g clipPath="url(#clip0_454_5099)">
        <path
          d="M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z"
          fill="#FDE9C8"
        />
        <g clipPath="url(#clip1_454_5099)">
          <path
            d="M16.6875 11.3125H13.9375C13.558 11.3125 13.25 11.0052 13.25 10.625C13.25 10.2448 13.558 9.9375 13.9375 9.9375H16.6875C17.067 9.9375 17.375 10.2448 17.375 10.625C17.375 11.0052 17.067 11.3125 16.6875 11.3125Z"
            fill="#977334"
          />
          <path
            d="M16.6875 8.5625H13.9375C13.558 8.5625 13.25 8.25519 13.25 7.875C13.25 7.49481 13.558 7.1875 13.9375 7.1875H16.6875C17.067 7.1875 17.375 7.49481 17.375 7.875C17.375 8.25519 17.067 8.5625 16.6875 8.5625Z"
            fill="#977334"
          />
          <path
            d="M16.6875 14.0625H13.9375C13.558 14.0625 13.25 13.7552 13.25 13.375C13.25 12.9948 13.558 12.6875 13.9375 12.6875H16.6875C17.067 12.6875 17.375 12.9948 17.375 13.375C17.375 13.7552 17.067 14.0625 16.6875 14.0625Z"
            fill="#977334"
          />
          <path
            d="M16.6875 16.8125H7.0625C6.683 16.8125 6.375 16.5052 6.375 16.125C6.375 15.7448 6.683 15.4375 7.0625 15.4375H16.6875C17.067 15.4375 17.375 15.7448 17.375 16.125C17.375 16.5052 17.067 16.8125 16.6875 16.8125Z"
            fill="#977334"
          />
          <path
            d="M7.69084 13.6541L8.12121 12.6854C8.12465 12.6854 8.12809 12.6875 8.13152 12.6875H10.8815C10.885 12.6875 10.8884 12.6854 10.8918 12.6854L11.3222 13.6541C11.4363 13.9106 11.6873 14.0625 11.9513 14.0625C12.0448 14.0625 12.139 14.0433 12.2297 14.0027C12.5769 13.8487 12.7323 13.4424 12.579 13.0952L10.1356 7.59587C10.0249 7.34769 9.77877 7.1875 9.50721 7.1875C9.23565 7.1875 8.98952 7.34769 8.87884 7.59587L6.43409 13.0959C6.28009 13.4431 6.43615 13.8494 6.78334 14.0034C7.13121 14.1594 7.53684 14.0006 7.69084 13.6541ZM9.50721 9.56694L10.2827 11.3118H8.73171L9.50721 9.56694Z"
            fill="#977334"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_454_5099">
          <rect width="24" height="24" fill="white" />
        </clipPath>
        <clipPath id="clip1_454_5099">
          <rect width="11" height="11" fill="white" transform="translate(6.375 6.5)" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
